import axios from "axios";
import { auth } from "./firebase";

const axiosInstance = axios.create({
	baseURL: `${process.env.STORAGE_API_BASE_URL || process.env.API_BASE_URL}`,
	headers: {
		Accepted: "appication/json",
		"Content-Type": "multipart/form-data",
	},
});

axiosInstance.interceptors.request.use(
	(config) => {
		const user = JSON.parse(localStorage.getItem("au") || "{}");
		if (user) {
			config.headers.authorization = user.aut;
			config.headers.apiKey = process.env.API_KEY;
		}
		return config;
	},
	(error) => Promise.reject(error)
);

// A cached token can still be stale (e.g. the tab was backgrounded long
// enough for the SDK's own proactive refresh to fall behind). On a 401,
// force a fresh token once and retry - if that still fails, the token
// wasn't the problem, so surface the error as usual.
axiosInstance.interceptors.response.use(
	(response) => response,
	async (error) => {
		const originalRequest = error.config;
		if (
			error.response?.status === 401 &&
			originalRequest &&
			!originalRequest._retry &&
			auth.currentUser
		) {
			originalRequest._retry = true;
			try {
				const token = await auth.currentUser.getIdToken(true);
				const user = JSON.parse(localStorage.getItem("au") || "{}");
				user.aut = token;
				localStorage.setItem("au", JSON.stringify(user));
				originalRequest.headers.authorization = token;
				return axiosInstance(originalRequest);
			} catch (refreshError) {
				return Promise.reject(refreshError);
			}
		}
		return Promise.reject(error);
	}
);

export default axiosInstance;
